import { render, staticRenderFns } from "./seniority-remuneration-table.component.vue?vue&type=template&id=8cff2bc4&scoped=true&"
import script from "./seniority-remuneration-table.component.vue?vue&type=script&lang=ts&"
export * from "./seniority-remuneration-table.component.vue?vue&type=script&lang=ts&"
import style0 from "./seniority-remuneration-table.component.vue?vue&type=style&index=0&id=8cff2bc4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cff2bc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
